/** Фиксит https://youtrack.mamba.ru/issue/M-2363 */
export const switchBodyOverflow = (hidden: boolean) => {
  const {
    body: { style },
  } = document

  if (hidden && style.overflow !== 'hidden') {
    style.overflow = 'hidden'
    return
  }

  if (!hidden && style.overflow === 'hidden') {
    style.overflow = ''
  }
}
